import React, { memo, useEffect, useRef, useState } from "react";

// bootstrap
import { Col, Row, Table } from "react-bootstrap";

import AppFormikInputInline from "utlis/helpers/forms/AppFormikInputInline";
import AppFormikInputFieldRadio from "utlis/helpers/forms/AppFormikInputFieldRadio";

function FormPurchaseOrders__VendorInfo(props) {
  const { formik, selectedVendor,
    foundVendors, filter, setFoundVendors, setSelectedVendor_,
    getVendorAddresses_,
    //  setAddresses, setBAddress, setSAddress 
  } = props;
  const [value, setValue] = useState("")
  const ref = useRef()

  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (foundVendors && ref.current && !ref.current.contains(e.target)) {
        setFoundVendors(false)
      }
    }
    document.addEventListener("mousedown", checkIfClickedOutside)
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [])

  return (
    <React.Fragment >
      {/* form field */}
      <Row >
        <Col xs={12} md={9} lg={12}>
          <div className={"sale-order-label"}>Purchase Order For</div>
          <div
            className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${formik.touched.active && formik.errors.active
              ? "has-msg msg-error"
              : ""
              }`}
          >
            <div className="media-body st-form-input-container align-left">
              <label>
                <input
                  name="u"
                  type="radio"
                  className="custom-radio"
                  value="0"
                  checked={!selectedVendor.isNew}
                  onChange={(e) => {
                    setSelectedVendor_({ ...selectedVendor, isNew: false })
                    formik.resetForm()
                    // setAddresses(arr => [])
                    // setSAddress({})
                    // setBAddress({})
                  }}
                />
                {"   "}
                {` Existing Vendor `}
              </label>
              <label className="ms-3">
                <input
                  name="u"
                  type="radio"
                  value="1"
                  className="custom-radio"
                  checked={selectedVendor.isNew}
                  onChange={(e) => {
                    setSelectedVendor_({ ...selectedVendor, isNew: true })
                    // setTimeout(() => {
                    //   formik.resetForm()
                    // }, 200);
                    // setAddresses(arr => [])
                    // setSAddress({})
                    // setBAddress({})
                  }}
                />
                {` New Vendor `}
              </label>
              {
                /* form message */
                formik.touched.active && formik.errors.active && (
                  <div className="st-form-msg position-absolute">
                    <p className="st-fs-12">{formik.errors.active}</p>
                  </div>
                )
              }
            </div>
          </div>
        </Col>
      </Row>
      {!selectedVendor.isNew ? (
        <Row className={'sale-order-for'} id="customer-info">
          <Col xs={12} md={9} lg={12} className="st-form d-flex align-items-center">
            <label className=" st-label-with-left me-2" >Search</label>
            <input type="text" className="form-control" placeholder="Search by Vendor Name or Email Address"
              onChange={(e) => {
                setValue(e.target.value)
                filter(e)
              }}
              value={value}
            />
          </Col>
          {(foundVendors && (foundVendors.length > 0)) ?
            <div className="app-card-content bg-white border st-border-light st-default-rounded-block 
              customer-list st-listing-table " ref={ref}>
              <Table>
                <thead>
                </thead>
                <tbody>
                  {foundVendors.map((vendor) => (
                    <tr
                      key={vendor.vendor_id}
                      onClick={(e => {
                        vendor.isNew = false
                        setSelectedVendor_(vendor)
                        setFoundVendors(false)
                        getVendorAddresses_(vendor.vendor_id)
                        setValue("")
                      }
                      )}
                      style={{ width: "100%" }}
                    >
                      <td className="text-capitalize">{vendor.first_name}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div> :
            null
          }
          <Col xs={12} md={9} lg={12} className="">
            <div className="d-flex flex-wrap align-items-center ">
              <div className="st-text-color st-fw-600 st-fs-15">Selected Vendor: </div>
              <div className="media-body st-form-input-container text-left ms-2">
                <span className="text-capitalize">{selectedVendor.vendor_id ?
                  <div className="st-fs-15 st-fw-600 st-text-primary">{selectedVendor.first_name} {selectedVendor.middle_name} {selectedVendor.last_name}</div>
                  : "no vendor selected"}</span>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
              labelName={"First Name"}
              isRequired={true}
              placeholder={"First Name"}
              formikFieldName={"first_name"}
            />
          </Col>


          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Last Name"}
              isRequired={true}
              placeholder={"Last Name"}
              formikFieldName={"last_name"}
            />
          </Col>

          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Company Name"}
              placeholder={"Company Name"}
              formikFieldName={"company_name"}
              isRequired={true}
            />
          </Col>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center"}
              labelName={"Tax Id/EIN"}
              isRequired={true}
              placeholder={"XX-XXXXXXX"}
              inputType={"text"}
              formikFieldName={"license_number"}
              onChange={(e) => {
                let value = e.target.value
                value = value.replace(/[^0-9]/ig, '')
                if (value.length > 10) {
                  value = value.slice(0, 10)
                }

                if (value.length > 2) {
                  const v = value
                  const p1 = value.slice(0, 2)
                  const p2 = v.slice(2, v.length)
                  value = p1 + "-" + p2
                }
                formik?.setFieldValue("license_number", value)
              }}
            />

          </Col>

          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputInline
              formik={formik}
              stFormClass={
                "st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Email Address"}
              isRequired={true}
              placeholder={"Email Address"}
              formikFieldName={"email"}
            />
          </Col>
          <Col xs={12} md={9} lg={4} className="px-0">
            <AppFormikInputFieldRadio
              formik={formik}
              stFormClass={
                "st-form st-form-with-label-left d-flex flex-wrap align-items-center"
              }
              labelName={"Exclusive Offers"}
              formikFieldName={"exclusiveOffers"}
              labelNameRight={"I would like to receive updates and offers"}
            />
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
}

export default memo(FormPurchaseOrders__VendorInfo);
